/* DSV homepage v3. Native details and forms continue to work without JavaScript. */
(() => {
  const mobileCleanups = new WeakMap();
  const navigationCleanups = new WeakMap();
  function navigation(header, nav, menus, closeMenus) {
    const media = window.matchMedia('(min-width:901px) and (hover:hover) and (pointer:fine)');
    const abort = new AbortController(), options = {signal:abort.signal};
    let openTimer, closeTimer;
    const cancel = () => {clearTimeout(openTimer);clearTimeout(closeTimer);};
    const isMouse = event => media.matches && event.pointerType === 'mouse';
    menus.forEach(menu => {
      menu.addEventListener('pointerenter', event => {
        if (!isMouse(event)) return;
        cancel();
        if (menu.open) return;
        openTimer = setTimeout(() => {closeMenus(menu);menu.open = true;},100);
      },options);
      menu.addEventListener('pointerleave', event => {
        if (!isMouse(event)) return;
        cancel();
        closeTimer = setTimeout(() => {
          const focus = document.activeElement;
          if (menu.contains(focus) && focus.matches(':focus-visible')) return;
          menu.open = false;
        },180);
      },options);
    });
    nav.querySelectorAll('.dsv-nav-direct').forEach(link => {
      link.addEventListener('pointerenter', event => {if (isMouse(event)) {cancel();closeMenus();}},options);
    });
    header.addEventListener('keydown', event => {if (event.key === 'Escape') cancel();},options);
    header.addEventListener('click', cancel,options);
    media.addEventListener('change', () => {cancel();closeMenus();},options);

    // Derive the active menu from the current URL, including links in rich-text columns.
    // A direct link takes priority over a duplicate link inside another submenu.
    function currentPage() {
      const path = value => value.replace(/\/+$/,'') || '/';
      const matches = [...nav.querySelectorAll('a[href]')].filter(link => {
        const url = new URL(link.href,window.location.href);
        if (url.origin !== window.location.origin || path(url.pathname) !== path(window.location.pathname)) return false;
        return !url.hash || url.hash === window.location.hash;
      });
      nav.querySelectorAll('.is-current').forEach(item => item.classList.remove('is-current'));
      nav.querySelectorAll('a[aria-current="page"]').forEach(link => link.removeAttribute('aria-current'));
      const active = matches.find(link => link.classList.contains('dsv-nav-direct')) || matches[0];
      if (active) {
        active.setAttribute('aria-current','page');
        (active.closest('.dsv-menu-item') || active).classList.add('is-current');
      }
    }
    currentPage();
    window.addEventListener('hashchange',currentPage,options);
    window.addEventListener('pageshow',currentPage,options);
    navigationCleanups.set(header,() => {cancel();abort.abort();});
  }
  function mobileHeader(header, nav, toggle, closeMenus) {
    const body = header.querySelector('.dsv-header-body');
    const search = header.querySelector('.dsv-search');
    const input = search.querySelector('[name="q"]');
    if (!body || !window.IntersectionObserver) return;
    const media = window.matchMedia('(max-width:900px)');
    const abort = new AbortController(), options = {signal:abort.signal};
    const originalHeight = header.style.height, placeholder = input.placeholder;
    let active = false, frame = 0, observer, width = window.innerWidth;
    const close = () => {nav.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');closeMenus();};
    const viewport = () => {
      body.style.setProperty('--dsv-visual-height', `${window.visualViewport?.height || window.innerHeight}px`);
      body.style.setProperty('--dsv-visual-top', `${window.visualViewport?.offsetTop || 0}px`);
    };
    function observe() {
      observer?.disconnect();
      if (!media.matches) return;
      observer = new IntersectionObserver(schedule, {rootMargin:`-${active ? 112 : 72}px 0px 0px 0px`,threshold:[0,1]});
      observer.observe(header);
    }
    function setActive(value) {
      if (value === active) return;
      if (value) header.style.height = `${header.getBoundingClientRect().height}px`;
      body.classList.toggle('is-compact',value);
      if (!value) header.style.height = originalHeight;
      input.placeholder = value ? 'Zoek een spel…' : placeholder;
      active = value;observe();viewport();
    }
    function sync() {
      frame = 0;
      if (!media.matches) {setActive(false);return;}
      if (nav.classList.contains('is-open') || search.contains(document.activeElement)) return;
      setActive(header.getBoundingClientRect().bottom <= (active ? 112 : 72));
    }
    function schedule() {if (!frame) frame = requestAnimationFrame(sync);}
    function responsive() {close();setActive(false);observe();schedule();viewport();}
    media.addEventListener('change',responsive,options);
    window.addEventListener('resize',() => {
      if (width !== window.innerWidth) {width = window.innerWidth;responsive();}
      viewport();
    },options);
    window.addEventListener('pageshow',schedule,options);
    window.visualViewport?.addEventListener('resize',viewport,options);
    window.visualViewport?.addEventListener('scroll',viewport,options);
    search.addEventListener('focusin',close,options);
    header.addEventListener('focusout',schedule,options);
    toggle.addEventListener('click',schedule,options);
    nav.addEventListener('click',schedule,options);
    document.addEventListener('pointerdown',event => {if (!header.contains(event.target)) {close();schedule();}},options);
    responsive();
    mobileCleanups.set(header,() => {
      abort.abort();observer?.disconnect();cancelAnimationFrame(frame);
      body.classList.remove('is-compact');header.style.height = originalHeight;input.placeholder = placeholder;
    });
  }
  function init(scope) {
    scope.querySelectorAll('[data-dsv-video]').forEach(hero => {
      if (hero.dataset.dsvVideoReady) return;
      hero.dataset.dsvVideoReady = 'true';
      const video = hero.querySelector('video'), button = hero.querySelector('[data-dsv-video-toggle]');
      if (!video || !button) return;
      button.hidden = false;
      const sync = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; button.setAttribute('aria-label', button.textContent); };
      const play = () => { const promise = video.play(); if (promise && promise.catch) promise.catch(sync); };
      button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); });
      video.addEventListener('play', sync); video.addEventListener('pause', sync); sync();
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!(reduced && reduced.matches) && !(navigator.connection && navigator.connection.saveData)) play();
      if (reduced && reduced.addEventListener) reduced.addEventListener('change', event => { if (event.matches) video.pause(); });
    });
    scope.querySelectorAll('[data-dsv-header]').forEach(header => {
      if (header.dataset.dsvReady) return;
      header.dataset.dsvReady = 'true';
      const nav = header.querySelector('.dsv-nav');
      const toggle = header.querySelector('[data-dsv-menu-toggle]');
      const menus = [...header.querySelectorAll('.dsv-menu-item')];
      const closeMenus = except => menus.forEach(menu => { if (menu !== except) menu.open = false; });
      toggle.addEventListener('click', () => {
        const open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        if (!open) closeMenus();
      });
      menus.forEach(menu => {
        menu.addEventListener('toggle', () => { if (menu.open) closeMenus(menu); });
      });
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = menus.find(menu => menu.open);
        closeMenus();
        if (open) open.querySelector('summary').focus();
        else { nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
      });
      nav.addEventListener('click', event => {
        if (!event.target.closest('a')) return;
        closeMenus(); nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false');
      });
      header.addEventListener('focusout', event => { if (event.relatedTarget && !header.contains(event.relatedTarget)) closeMenus(); });
      navigation(header, nav, menus, closeMenus);
      mobileHeader(header, nav, toggle, closeMenus);
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-dsv-header]').forEach(header => {
      if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-dsv-header]').forEach(header => {
      navigationCleanups.get(header)?.();
      mobileCleanups.get(header)?.();
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const block = event.target.closest('.dsv-menu-item');
    if (block) {
      const header = block.closest('[data-dsv-header]');
      header.querySelectorAll('.dsv-menu-item').forEach(menu => { menu.open = menu === block; });
      header.querySelector('.dsv-nav').classList.add('is-open');
      header.querySelector('[data-dsv-menu-toggle]').setAttribute('aria-expanded', 'true');
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();
